import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["suggestionsContainer"]
  }

  connect() {
    this.checkForInterFundTransfer()
  }

  accountChanged(event) {
    this.checkForInterFundTransfer()
  }

  amountChanged(event) {
    this.checkForInterFundTransfer()
  }

  async checkForInterFundTransfer() {
    const entries = this.collectEntries()
    
    if (!this.hasMultipleFunds(entries)) {
      this.clearSuggestions()
      return
    }

    await this.fetchSuggestions(entries)
  }

  collectEntries() {
    const entries = []
    const entryRows = this.element.querySelectorAll('[data-gl-entry-row]')
    
    entryRows.forEach(row => {
      const accountSelect = row.querySelector('select[name*="[gl_account_id]"]')
      const amountInput = row.querySelector('input[name*="[amount]"]')
      const bookedInput = row.querySelector('input[name*="[when_booked]"]')
      const chargedInput = row.querySelector('input[name*="[when_charged]"]')
      const descriptionInput = row.querySelector('input[name*="[description]"]')
      
      if (accountSelect && accountSelect.value && amountInput && amountInput.value) {
        entries.push({
          gl_account_id: accountSelect.value,
          amount: amountInput.value,
          when_booked: (bookedInput && bookedInput.value) || this.data.get("transactionDateValue"),
          when_charged: (chargedInput && chargedInput.value) || this.data.get("transactionDateValue"),
          description: (descriptionInput && descriptionInput.value) || ''
        })
      }
    })
    
    return entries
  }

  hasMultipleFunds(entries) {
    const fundIds = new Set()
    
    entries.forEach(entry => {
      const accountOption = document.querySelector(`option[value="${entry.gl_account_id}"]`)
      const fundId = accountOption && accountOption.dataset.fundId
      if (fundId) {
        fundIds.add(fundId)
      }
    })
    
    return fundIds.size > 1
  }

  async fetchSuggestions(entries) {
    try {
      const response = await fetch(this.data.get("suggestionsUrlValue"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: JSON.stringify({
          entries: entries,
          transaction_date: this.data.get("transactionDateValue")
        })
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error)
    }
  }

  clearSuggestions() {
    if (this.hasSuggestionsContainerTarget) {
      this.suggestionsContainerTarget.innerHTML = ''
    }
  }

  acceptSuggestion(event) {
    event.preventDefault()
    const button = event.currentTarget
    const suggestionRow = button.closest('[data-suggestion-row]')
    
    if (suggestionRow) {
      // Convert suggestion to regular entry
      suggestionRow.removeAttribute('data-suggestion-row')
      suggestionRow.classList.remove('bg-blue-50', 'border-blue-200')
      
      // Remove the accept/dismiss buttons
      const actionsContainer = suggestionRow.querySelector('[data-suggestion-actions]')
      if (actionsContainer) {
        actionsContainer.remove()
      }
      
      // Move to main entries container
      const entriesContainer = document.getElementById('gl_entries')
      if (entriesContainer) {
        entriesContainer.appendChild(suggestionRow)
      }
      
      // Update field names to match the form's nested attributes structure
      this.updateFieldNames(suggestionRow)
    }
  }

  dismissSuggestion(event) {
    event.preventDefault()
    const button = event.currentTarget
    const suggestionRow = button.closest('[data-suggestion-row]')
    
    if (suggestionRow) {
      suggestionRow.remove()
      
      // Check if we need to hide the suggestions container
      const remainingSuggestions = this.suggestionsContainerTarget.querySelectorAll('[data-suggestion-row]')
      if (remainingSuggestions.length === 0) {
        this.clearSuggestions()
      }
    }
  }

  updateFieldNames(row) {
    // Get the current highest index from existing entries
    const entriesContainer = document.getElementById('gl_entries')
    if (!entriesContainer) return
    
    // Find the highest index currently in use
    let highestIndex = -1
    const existingFields = entriesContainer.querySelectorAll('input[name*="[gl_entries_attributes]"]')
    existingFields.forEach(field => {
      const indexMatch = field.name.match(/\[gl_entries_attributes\]\[(\d+)\]/)
      if (indexMatch) {
        const index = parseInt(indexMatch[1])
        if (index > highestIndex) {
          highestIndex = index
        }
      }
    })
    
    // New entry gets the next index
    const newIndex = highestIndex + 1
    
    // Update all input/select field names to match Rails nested attributes format
    const fields = row.querySelectorAll('input, select')
    fields.forEach(field => {
      if (field.name) {
        // Extract just the field name from suggestion[index][fieldname]
        const match = field.name.match(/\[([^\]]+)\]$/)
        const fieldName = match && match[1]
        if (fieldName) {
          field.name = `gl_transaction[gl_entries_attributes][${newIndex}][${fieldName}]`
        }
      }
    })
    
    // Also add the data-gl-entry-row attribute to mark it as a regular entry
    row.setAttribute('data-gl-entry-row', 'true')
  }
}